import { EinzaApiService } from "@/services/einzaApi"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryAllMixProducts = {
  async allMixProducts(parent, args, context, info) {
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.MIXED_PRODUCTS,
      operation: Operations.READ,
    })

    try {
      const dataResponse = await EinzaApiService.getData("produkte/findAll")

      if (dataResponse?.data && dataResponse?.data.length >= 1) {
        const { data } = dataResponse

        return {
          total: data.length,
          items: data.map((mixProduct) => {
            return {
              productId: mixProduct.vkProduktid,
              description: mixProduct.bezeichnung,
              systemId: mixProduct.systemid,
              creationDate: mixProduct.anlDatum,
              creationUser: mixProduct.anlVerk,
              modificationDate: mixProduct.modDatum,
              modificationUser: mixProduct.modVerk,
              status: mixProduct.status,
              sysId: mixProduct.sysId,
              systemVersion: mixProduct.sysVersion,
            }
          }),
        }
      }

      return null
    } catch (err) {
      throw new Error(err)
    }
  },
}
